export default __webpack_public_path__ + "static/shamir-logo-27af98ec132d6adbb6f5638bf235d726.svg";